import { Signal } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { Graduation } from '../graduation-view.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, accAreaService: AcceleratorAreaService, canVenturesBeGraduated: Signal<boolean>): GridSetup<Graduation> {

	return {
		rowName: { singular: 'Venture', plural: 'Ventures' },
		getRowKey: row => '' + row.accVentureId,
		stateKey: 'accelerator-graduation-grid',
		actions: getActions(dialogService, accAreaService),
		buttons: getButtons(dialogService, accAreaService, canVenturesBeGraduated),
		columns: getColumns(util),
	}
}
